import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/recollects/new',
  title: 'title.new',
  endpoint: '/app/purchase/request_recollect',
  breadcrumbs: [],
}
